(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  class ProductImageZoom {
    constructor() {
      this.initZoom();
      this.bindEvents();
    }

    initZoom() {
      // Only initialize zoom containers that have the data-zoom-container attribute (product pages only)
      this.zoomContainers = document.querySelectorAll('[data-zoom-container]');
      this.currentScale = 1;
      this.maxScale = 3;
      this.minScale = 1;
      this.clickZoomScale = 2; // Slightly less zoom for click (you can adjust this)
      this.isZoomed = false;
      this.isClickZoomed = false; // Track if zoom was triggered by click
      this.zoomOrigin = { x: 50, y: 50 }; // Store the zoom origin point
    }

    bindEvents() {
      this.zoomContainers.forEach(container => {
        const image = container.querySelector('.zoom-image');
        const zoomIndicator = container.querySelector('[data-zoom-indicator]');
        
        if (!image) return;

        // Add click event to zoom indicator
        if (zoomIndicator) {
          zoomIndicator.addEventListener('click', (e) => this.handleIndicatorClick(e, container, image));
        }

        // Desktop events
        if (window.innerWidth >= 750) {
          container.addEventListener('wheel', (e) => this.handleWheel(e, container, image));
          // container.addEventListener('mouseleave', () => this.resetZoom(container, image));
        }

        // Mobile events
        if (window.innerWidth < 750) {
          let initialDistance = 0;
          let initialScale = 1;

          container.addEventListener('touchstart', (e) => {
            if (e.touches.length === 2) {
              initialDistance = this.getDistance(e.touches[0], e.touches[1]);
              initialScale = this.currentScale;
              
              const rect = container.getBoundingClientRect();
              const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
              const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
              
              // Only update origin if not already zoomed
              if (!this.isZoomed) {
                this.zoomOrigin.x = ((centerX - rect.left) / rect.width) * 100;
                this.zoomOrigin.y = ((centerY - rect.top) / rect.height) * 100;
              }
            }
          });

          container.addEventListener('touchmove', (e) => {
            if (e.touches.length === 2) {
              e.preventDefault();
              const currentDistance = this.getDistance(e.touches[0], e.touches[1]);
              const scale = initialScale * (currentDistance / initialDistance);
              this.setZoom(Math.max(this.minScale, Math.min(this.maxScale, scale)), container, image);
            }
          });

          container.addEventListener('touchend', (e) => {
            if (e.touches.length < 2) {
              if (this.currentScale <= this.minScale) {
                this.resetZoom(container, image);
              }
            }
          });
        }
      });
    }

    handleIndicatorClick(e, container, image) {
      e.preventDefault();
      e.stopPropagation();
      
      if (this.isZoomed) {
        // If already zoomed, zoom out
        this.resetZoom(container, image);
      } else {
        // If not zoomed, zoom in to center
        this.zoomOrigin.x = 50; // Center horizontally
        this.zoomOrigin.y = 50; // Center vertically
        this.isClickZoomed = true;
        this.setZoom(this.clickZoomScale, container, image);
      }
    }

    handleWheel(e, container, image) {
      e.preventDefault();
      
      const delta = e.deltaY > 0 ? -0.2 : 0.2;
      
      // Reset click zoom state when using wheel
      this.isClickZoomed = false;
      
      // We only set a new zoom origin point if the user is zooming IN (delta > 0)
      // AND the image is NOT ALREADY ZOOMED (`!this.isZoomed`).
      // This "locks" the origin point after the first zoom-in.
      if (delta > 0 && !this.isZoomed) {
        const rect = container.getBoundingClientRect();
        this.zoomOrigin.x = ((e.clientX - rect.left) / rect.width) * 100;
        this.zoomOrigin.y = ((e.clientY - rect.top) / rect.height) * 100;
      }
      
      const newScale = Math.max(this.minScale, Math.min(this.maxScale, this.currentScale + delta));
      
      this.setZoom(newScale, container, image);
    }

    setZoom(scale, container, image) {
      this.currentScale = scale;
      this.isZoomed = scale > this.minScale;
      
      container.classList.toggle('zoomed', this.isZoomed);
      
      image.style.transform = `scale(${scale})`;
      image.style.transformOrigin = `${this.zoomOrigin.x}% ${this.zoomOrigin.y}%`;
      
      // Update zoom indicator state
      this.updateZoomIndicator(container);
      
      // If we have zoomed all the way out, wait for the transition to finish, then reset origin.
      if (!this.isZoomed) {
        setTimeout(() => {
          // Check again in case the user zoomed back in quickly
          if (this.currentScale === this.minScale) {
            image.style.transformOrigin = 'center';
          }
        }, 300); // This must match your CSS transition duration
      }
    }

    updateZoomIndicator(container) {
      const zoomIndicator = container.querySelector('[data-zoom-indicator]');
      if (zoomIndicator) {
        // Update the icon based on zoom state
        const svg = zoomIndicator.querySelector('svg');
        if (svg) {
          if (this.isZoomed) {
            // Change to zoom-out icon (minus sign)
            svg.innerHTML = `
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
              <line x1="8" y1="11" x2="14" y2="11"></line>
            `;
          } else {
            // Change to zoom-in icon (plus sign)
            svg.innerHTML = `
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
              <line x1="11" y1="8" x2="11" y2="14"></line>
              <line x1="8" y1="11" x2="14" y2="11"></line>
            `;
          }
        }
      }
    }

    resetZoom(container, image) {
      this.currentScale = this.minScale;
      this.isZoomed = false;
      this.isClickZoomed = false;
      container.classList.remove('zoomed');
      image.style.transform = 'scale(1)';
      image.style.transformOrigin = 'center';
      this.zoomOrigin = { x: 50, y: 50 };
      
      // Update zoom indicator state
      this.updateZoomIndicator(container);
    }

    getDistance(touch1, touch2) {
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
  }

  // Initialize zoom functionality only if zoom containers exist (product pages only)
  if (document.querySelectorAll('[data-zoom-container]').length > 0) {
    new ProductImageZoom();
  }
});
  } catch(e) { console.error(e); }
})();

})();
